import { useState } from 'react';
import { useForm } from 'react-hook-form';

import FeedbackDisplay, {
  FeedbackRating,
  Inputs,
} from './impl/FeedbackDisplay';
import useSendFeedback from './impl/useSendFeedback';

const Feedback: React.FC = () => {
  const [feedbackRating, setFeedbackRating] = useState<FeedbackRating>(0);
  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>({
    mode: 'onBlur',
    defaultValues: { email: '', message: '' },
  });

  const { sendFeedback, isLoading } = useSendFeedback(() => {
    reset();
    setFeedbackRating(0);
    setSuccess(true);
  });

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSubmit((data) =>
      sendFeedback({
        rating: feedbackRating,
        email: data.email,
        message: data.message,
      }),
    )();
  };

  const onClickThumb = (rating: FeedbackRating) => {
    if (rating === feedbackRating) {
      setFeedbackRating(0);
    } else {
      setFeedbackRating(rating);
      setSuccess(false);
    }
  };

  return (
    <FeedbackDisplay
      isLoading={isLoading}
      success={success}
      feedbackRating={feedbackRating}
      errors={errors}
      onClickThumb={onClickThumb}
      onSubmit={onSubmit}
      register={register}
    />
  );
};

export default Feedback;
